import { array, defineAction, enumerated, number, object } from '~/prix'
import migrationMigrateOlapAction from './migrationMigrateOlap.action.json' assert { type: 'json' }

const migrationMigrateOlapDefinition = defineAction({
  ...migrationMigrateOlapAction,
  input: object({}),
  output: object({
    results: array(
      object({
        timestamp: number(),
        result: enumerated({ success: 'Sucesso', skip: 'Já executada' }),
      }),
    ),
  }),
})

export default migrationMigrateOlapDefinition
